import React from 'react'
import optimizeImgix from '../../globals/optimize-imgix'
import placeholderImgix from '../../globals/placeholder-imgix'

import Media from 'lemon-campaign-ui/lib/molecules/Media'
import { getVisible } from '../../globals/visible-components'

export default ({ component, defaults }) => {
  const visible = getVisible(component._id)

  let placeholder = placeholderImgix(component.content.src,
    component.content.size)
  let src = optimizeImgix(component.content.src, component.content.size).url
  let videoId = component.content.video

  if (!visible && component.content.srcType !== 'icon') {
    return null
  }

  return (
    <Media
      {...defaults}
      fixedPlaceholder={true}
      size={component.content.size}
      src={src}
      placeholder={placeholder}
      video={videoId}
      controls={true}
      type={component.content.srcType}
      icon={component.content.icon}
      iconColor={component.content.iconColor}
      preventDesktopBehaviour={component.content.size === 'answer'}
    />
  )
}
